import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, InputLabel, Divider, Grid, Paper, Toolbar, CircularProgress } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { useDispatch, useSelector } from "react-redux";
import clsx from 'clsx';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    headerTitle: {
        fontWeight: 'bold',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading,
    displayOnRole: {
        display: 'none'
    },
})

const payOffListSelector = (state) => state.PayOffList;
const IdentitySelector = (state) => state.Identity;

// 精算詳細画面
const PayOffDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();

    // useSelector で store の state を取得。
    const { listDetail, nowWainting } = useSelector(payOffListSelector);
    const { userData } = useSelector(IdentitySelector);


    const { classes } = props;

    const listDefinition = {
        columns: [
            {
                // 処理日時
                title: <FormattedMessage id="Adjustment.ProcessingDate" />,
                field: 'transaction_dt',
                type: 'datetime',
                filtering: false
            },
            {
                // 種別
                title: <FormattedMessage id="Adjustment.Type" />,
                field: 'transaction_type_name',
                filtering: true,
            },
            {
                // 金額
                title: <FormattedMessage id="Adjustment.AmountOfMoney" />,
                field: 'payment_amount',
                type: 'currency',
                currencySetting: { currencyCode: 'JPY', minimumFractionDigits: 0, maximumFractionDigits: 0 },
                filtering: false
            },
        ]
    };

   /**
    * 
    * 戻る押下時の処理
    *
    */
    const onBackClick = () => {
        props.onCancel();
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    if (listDetail == null || listDetail.length == 0) {
        return <div>データが存在しません。</div>;
    }

    // 確定日
    const fdt = new Date(props.fixedDt);
    var fixDt = fdt.getFullYear() + '年' + ("0" + (fdt.getMonth() + 1)).slice(-2) + '月' + ("0" + fdt.getDate()).slice(-2) + '日';

    // 日付
    const ndt = new Date(props.nengappi);
    var nengappiDt = ndt.getFullYear() + '年' + ("0" + (ndt.getMonth() + 1)).slice(-2) + '月' + ("0" + ndt.getDate()).slice(-2) + '日';

    // 手数料
    var systemFeeOkicaCardPayment = Number(listDetail[0].system_fee_okica_card_payment).toFixed(2);
    var brandFeeOkicaCardPayment = Number(listDetail[0].brand_fee_okica_card_payment).toFixed(2);
    var systemFeeQrPayment = Number(listDetail[0].system_fee_qr_payment).toFixed(2);
    var brandFeeQrPayment = Number(listDetail[0].brand_fee_qr_payment).toFixed(2);
    var merchantFeeOkicaCardCharge = Number(listDetail[0].merchant_fee_okica_card_charge).toFixed(2);
    var merchantFeeOkicaCardValueExchange = Number(listDetail[0].merchant_fee_okica_card_value_exchange).toFixed(2);
    var systemFeeCreditCardPayment = Number(listDetail[0].system_fee_credit_card_payment).toFixed(2);
    var brandFeeCreditCardPayment = Number(listDetail[0].brand_fee_credit_card_payment).toFixed(2);
    var systemFeeBankPayment = Number(listDetail[0].system_fee_bank_payment).toFixed(2);
    var brandFeeBankPayment = Number(listDetail[0].brand_fee_bank_payment).toFixed(2);

    // 加盟店でブランド手数料は、非表示
    var brandDisplay = (userData.role < 4) ? false : true;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Adjustment.SettlementDetail" />}</Typography>
                    </div>
                </Toolbar>

                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantName}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.MerchantType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{props.merchantType}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.FixedDate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{fixDt}</InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Adjustment.Date"} /></InputLabel>
                    </Grid>
                    <Grid item xs={3}>
                        <InputLabel component="legend">{nengappiDt}</InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFeeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardPayment"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{systemFeeOkicaCardPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend">{brandFeeOkicaCardPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.QRBalanceSettlement"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{systemFeeQrPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>                    
                    <Grid item xs={2} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend">{brandFeeQrPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.ChargeCommissionRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.OKICACardCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{merchantFeeOkicaCardCharge}%</InputLabel>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: true })}>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: true })}>
                        <InputLabel component="legend" ><FormattedMessage id={"Merchant.OKICACardValue"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2} className={clsx({ [classes.displayOnRole]: true })}>
                        <InputLabel component="legend" >{merchantFeeOkicaCardValueExchange}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CreditFeeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{systemFeeCreditCardPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend">{brandFeeCreditCardPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                    <Grid item xs={5}>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BankChargeRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.SystemFee"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2}>
                        <InputLabel component="legend">{systemFeeBankPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                    </Grid>
                    <Grid item xs={4} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BrandCharge"} /></InputLabel>
                    </Grid>
                    <Grid item xs={2} className={clsx({ [classes.displayOnRole]: brandDisplay })}>
                        <InputLabel component="legend">{brandFeeBankPayment}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                    </Grid>
                </Grid>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{<FormattedMessage id="Adjustment.ResultsTitle" />}</Typography>}
                columns={listDefinition.columns}
                data={listDetail}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（なし）
                    Action: actionProps => {
                        return (
                            <div></div>
                        )
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>

            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PayOffDetail);
